<template>
  <div class="body-mobile">
    <index-header page="home"></index-header>
    <div class="_img_box" v-if="studentType===1">
      <img :src="config.web.leadingPicKinder" alt="帮助文档" />

      <a :href="config.web.handleBookKinder" target="_blank">
        <a-icon type="file-text" />
        下载操作文档
      </a>
    </div>
    <div class="_img_box" v-else>
      <img :src="config.web.leadingPicSchool" alt="帮助文档" />

      <a :href="config.web.handleBookSchool" target="_blank">
        <a-icon type="file-text" />
        下载操作文档
      </a>
    </div>
  </div>
</template>

<script>
  import IndexHeader from './components/IndexHeader';
  import IndexCommon from '../index/mixins/index_common';
  import config from '../../../config';
  export default {
    name: 'app',
    mixins: [IndexCommon],
    components: {
      IndexHeader
    },

    data () {
      return {
        config,
        relation: '本人',
        isPickerShow: false,
        actionBarData: [{
          text: '我要投保'
        }],
        pickerData: [[{text:'本人'},{text:'父母'},{text:'配偶'},{text:'子女'}]]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .detail{
    background: #fff;
    font-size: .24rem;
  }
  .block{
    margin-top: .32rem;
  }
  .agree{
    padding: .32rem;
    font-size: .24rem;
    color: #666;
  }

  ._img_box
    background-color #fff
    text-align center
    img
      width 100%
    a
      padding 20px
      font-size 24px
</style>
